function timezoneList() {
  return [
    { key: 'honolulu', label: '(GMT-10:00) Honolulu', value: '-10:00' },
    { key: 'anchorage', label: '(GMT-08:00) Anchorage', value: '-08:00' },
    { key: 'juneau', label: '(GMT-08:00) Juneau', value: '-08:00' },
    { key: 'hermosillo', label: '(GMT-07:00) Hermosillo', value: '-07:00' },
    { key: 'los-angeles', label: '(GMT-07:00) Los Angeles', value: '-07:00' },
    { key: 'phoenix', label: '(GMT-07:00) Phoenix', value: '-07:00' },
    { key: 'tijuana', label: '(GMT-07:00) Tijuana', value: '-07:00' },
    { key: 'vancouver', label: '(GMT-07:00) Vancouver', value: '-07:00' },
    { key: 'denver', label: '(GMT-06:00) Denver', value: '-06:00' },
    { key: 'easter', label: '(GMT-06:00) Easter', value: '-06:00' },
    { key: 'edmonton', label: '(GMT-06:00) Edmonton', value: '-06:00' },
    { key: 'mexico-city', label: '(GMT-06:00) Mexico City', value: '-06:00' },
    { key: 'bogota', label: '(GMT-05:00) Bogota', value: '-05:00' },
    { key: 'chicago', label: '(GMT-05:00) Chicago', value: '-05:00' },
    { key: 'rio-branco', label: '(GMT-05:00) Rio Branco', value: '-05:00' },
    { key: 'winnipeg', label: '(GMT-05:00) Winnipeg', value: '-05:00' },
    { key: 'detroit', label: '(GMT-04:00) Detroit', value: '-04:00' },
    { key: 'manaus', label: '(GMT-04:00) Manaus', value: '-04:00' },
    { key: 'new-york', label: '(GMT-04:00) New York', value: '-04:00' },
    { key: 'santiago', label: '(GMT-04:00) Santiago', value: '-04:00' },
    { key: 'toronto', label: '(GMT-04:00) Toronto', value: '-04:00' },
    { key: 'bahia', label: '(GMT-03:00) Bahia', value: '-03:00' },
    { key: 'belem', label: '(GMT-03:00) Belem', value: '-03:00' },
    { key: 'buenos-aires', label: '(GMT-03:00) Buenos Aires', value: '-03:00' },
    { key: 'halifax', label: '(GMT-03:00) Halifax', value: '-03:00' },
    { key: 'recife', label: '(GMT-03:00) Recife', value: '-03:00' },
    { key: 'sao-paulo', label: '(GMT-03:00) Sao Paulo', value: '-03:00' },
    { key: 'st-johns', label: '(GMT-02:30) St. John’s', value: '-02:30' },
    { key: 'noronha', label: '(GMT-02:00) Noronha', value: '-02:00' },
    { key: 'algiers', label: '(GMT+01:00) Algiers', value: '+01:00' },
    { key: 'canary', label: '(GMT+01:00) Canary', value: '+01:00' },
    { key: 'casablanca', label: '(GMT+01:00) Casablanca', value: '+01:00' },
    { key: 'dublin', label: '(GMT+01:00) Dublin', value: '+01:00' },
    { key: 'lagos', label: '(GMT+01:00) Lagos', value: '+01:00' },
    { key: 'london', label: '(GMT+01:00) London', value: '+01:00' },
    { key: 'tunis', label: '(GMT+01:00) Tunis', value: '+01:00' },
    { key: 'amsterdam', label: '(GMT+02:00) Amsterdam', value: '+02:00' },
    { key: 'berlin', label: '(GMT+02:00) Berlin', value: '+02:00' },
    { key: 'brussels', label: '(GMT+02:00) Brussels', value: '+02:00' },
    { key: 'budapest', label: '(GMT+02:00) Budapest', value: '+02:00' },
    { key: 'johannesburg', label: '(GMT+02:00) Johannesburg', value: '+02:00' },
    { key: 'kaliningrad', label: '(GMT+02:00) Kaliningrad', value: '+02:00' },
    { key: 'madrid', label: '(GMT+02:00) Madrid', value: '+02:00' },
    { key: 'paris', label: '(GMT+02:00) Paris', value: '+02:00' },
    { key: 'prague', label: '(GMT+02:00) Prague', value: '+02:00' },
    { key: 'rome', label: '(GMT+02:00) Rome', value: '+02:00' },
    { key: 'stockholm', label: '(GMT+02:00) Stockholm', value: '+02:00' },
    { key: 'warsaw', label: '(GMT+02:00) Warsaw', value: '+02:00' },
    { key: 'aden', label: '(GMT+03:00) Aden', value: '+03:00' },
    { key: 'amman', label: '(GMT+03:00) Amman', value: '+03:00' },
    { key: 'cairo', label: '(GMT+03:00) Cairo', value: '+03:00' },
    { key: 'jerusalem', label: '(GMT+03:00) Jerusalem', value: '+03:00' },
    { key: 'kampala', label: '(GMT+03:00) Kampala', value: '+03:00' },
    { key: 'moscow', label: '(GMT+03:00) Moscow', value: '+03:00' },
    { key: 'nairobi', label: '(GMT+03:00) Nairobi', value: '+03:00' },
    { key: 'riyadh', label: '(GMT+03:00) Riyadh', value: '+03:00' },
    { key: 'volgograd', label: '(GMT+03:00) Volgograd', value: '+03:00' },
    { key: 'yekaterinburg', label: '(GMT+05:00) Yekaterinburg', value: '+05:00' },
    { key: 'kolkata', label: '(GMT+05:30) Kolkata', value: '+05:30' },
    { key: 'omsk', label: '(GMT+06:00) Omsk', value: '+06:00' },
    { key: 'krasnoyarsk', label: '(GMT+07:00) Krasnoyarsk', value: '+07:00' },
    { key: 'novosibirsk', label: '(GMT+07:00) Novosibirsk', value: '+07:00' },
    { key: 'hong-kong', label: '(GMT+08:00) Hong Kong', value: '+08:00' },
    { key: 'irkutsk', label: '(GMT+08:00) Irkutsk', value: '+08:00' },
    { key: 'manila', label: '(GMT+08:00) Manila', value: '+08:00' },
    { key: 'perth', label: '(GMT+08:00) Perth', value: '+08:00' },
    { key: 'singapore', label: '(GMT+08:00) Singapore', value: '+08:00' },
    { key: 'taipei', label: '(GMT+08:00) Taipei', value: '+08:00' },
    { key: 'eucla', label: '(GMT+08:45) Eucla', value: '+08:45' },
    { key: 'seoul', label: '(GMT+09:00) Seoul', value: '+09:00' },
    { key: 'tokyo', label: '(GMT+09:00) Tokyo', value: '+09:00' },
    { key: 'yakutsk', label: '(GMT+09:00) Yakutsk', value: '+09:00' },
    { key: 'adelaide', label: '(GMT+09:30) Adelaide', value: '+09:30' },
    { key: 'darwin', label: '(GMT+09:30) Darwin', value: '+09:30' },
    { key: 'brisbane', label: '(GMT+10:00) Brisbane', value: '+10:00' },
    { key: 'hobart', label: '(GMT+10:00) Hobart', value: '+10:00' },
    { key: 'melbourne', label: '(GMT+10:00) Melbourne', value: '+10:00' },
    { key: 'sydney', label: '(GMT+10:00) Sydney', value: '+10:00' },
    { key: 'vladivostok', label: '(GMT+10:00) Vladivostok', value: '+10:00' },
    { key: 'sakhalin', label: '(GMT+11:00) Sakhalin', value: '+11:00' },
    { key: 'auckland', label: '(GMT+12:00) Auckland', value: '+12:00' },
    { key: 'kamchatka', label: '(GMT+12:00) Kamchatka', value: '+12:00' },
    { key: 'chatham', label: '(GMT+12:45) Chatham', value: '+12:45' }
  ]
}

export default timezoneList

